import { render } from "./DataTableCustom.vue?vue&type=template&id=39c8c72c"
import script from "./DataTableCustom.vue?vue&type=script&lang=js"
export * from "./DataTableCustom.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__